import PostRequest from "../../components/CTA/PostRequest";
import MovingServices from "../../components/CTA/MovingServices";

const AgentsSidebar = () => (
  <aside className="agents-sidebar">
    <PostRequest />
    <MovingServices />
  </aside>
);

export default AgentsSidebar;
